export default __webpack_public_path__ + "static/media/Trusted-by-customers.fd65de41.svg";